import { FunctionComponent } from "react";
import SvgIcon from "../SvgIcon";
import { ReactComponent as Close } from "./Close.svg";

interface Props {
	className?: string;
}

const IconClose: FunctionComponent<Props> = ({ className = "" }) => {
	return <SvgIcon className={className} svg={<Close />} />;
};

export default IconClose;
